import { HashRouter, BrowserRouter } from "react-router-dom";
import AppNavigation from "./Component/AppNavigation";
import { ToastContainer, Zoom } from "react-toastify";
import { Container } from "@mui/material";
import UnitTesting from "./ritetest/UnitTesting";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "./mapRedux/mapReduxProps";
import HOCReduxData from "./HOC/HOCReduxData";
import HoCtToastContainer from "./HOC/HoCtToastContainer";

function App(props) {
  return (
    <Container maxWidth={false}>
      <div className="App">
        <ToastContainer
          position="top-center"
          autoClose={4000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          transition={Zoom}
        />

        <HashRouter>
          <AppNavigation />
        </HashRouter>
      </div>
    </Container>
  );
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps
)(HOCReduxData(HoCtToastContainer(App)));
